module.exports = __webpack_public_path__ + "img/toolbar_bb.e31ec314.png";